export const paymentTypeOptions = [
  { value: 'cleaning_refund', displayValue: 'Refund (Cleaning)' },
  { value: 'rent_refund', displayValue: 'Refund (Rent)' },
  { value: 'utility', displayValue: 'Service Provider (Utility)' },
  { value: 'repair', displayValue: 'Service Provider (Repair)' },
];

export const isRefundPaymentType = (paymentType: string): boolean => {
  return ['cleaning_refund', 'rent_refund'].includes(paymentType);
};

export const isServiceProviderPaymentType = (paymentType: string): boolean => {
  return ['utility', 'repair'].includes(paymentType);
}; 